import { Credentials } from '../../types/Login';

export const USER_STORAGE_USER_KEY = 'user-key';

export const storeUser = (userObject: Credentials) => {
  return new Promise((resolve: any, reject) => {
    if (!userObject) {
      reject(new Error('Cannot store empty user'));
      return;
    }
    window.localStorage.setItem(
      USER_STORAGE_USER_KEY,
      JSON.stringify(userObject.access_token),
    );

    resolve();
  });
};

export const getUser = () => {
  const token = window.localStorage.getItem(USER_STORAGE_USER_KEY);

  return new Promise((resolve, reject) => {
    if (!!token && token.length) {
      resolve(JSON.parse(token));
      return;
    }
    reject(new Error('No user found'));
  });
};
